import { Environment } from '../../../environment';
import { v4 as uuidv4 } from 'uuid';
import axios, { AxiosError } from 'axios';
import { Api } from '../axiosApi';
export interface IListagemVeiculos {
  idveiculo: string;
  idtransportadora: string;
  placa: string;
  uf: string;
  rntrc: string;
  renavam: string;
  tara: number;
  capacidadekg: number;
  capacidadem3: number;
  tiporoda: number;
  tipocarroceria: number;
  tac: number;
}
export interface IDetalheVeiculo {
  idtransportadora: string;
  placa: string;
  uf: string; 
  rntrc: string;
  renavam: string;
  tara: number;
  capacidadekg: number;
  capacidadem3: number;
  tiporoda: number;
  tipocarroceria: number;
  tac: number;
}
type TotalCount = {
    data: IListagemVeiculos[];
    totalCount: number;
}
interface ErrorResponse {
  errors: {
    default: string;
  };
}
const getAll = async (idtransportadora: string, page = 1, tipo = '', filter = ''): Promise<TotalCount | Error> => {
  try {
    const urlRelativa = `/veiculos?idtransportadora=${idtransportadora}&page=${page}&limit=${Environment.LIMITE_DE_LINHAS}&tipo=${tipo}&filter=${filter}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      }; }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }}
};
const getById = async (id: string): Promise<IDetalheVeiculo | Error> => {
  try {
    const { data } = await Api.get(`/veiculos/${id}`);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const create = async (dados: IDetalheVeiculo): Promise<string | Error> => {
  try {
    const guuid = uuidv4();
    const { data } = await Api.post<IDetalheVeiculo>('/veiculos',  {idveiculo: guuid, ...dados});
    if (Object.keys(data).length === 0) {
      return guuid;
    }
    return new Error('Erro ao criar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    } }
};
const updateById = async (id: string, dados: IDetalheVeiculo): Promise<void | Error> => {
  try {
    await Api.put(`/veiculos/${id}`, dados);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }}
};
const deleteById = async (id: string): Promise<void | Error> => {
  try {
    await Api.delete(`/veiculos/${id}`);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    } }
};
const getAllList = async (idtransportadora = '', filter = '', id = ''): Promise<TotalCount | Error> => {
  try {
    const urlRelativa: string = id === '' ? `/veiculoslist?limit=${Environment.LIMITE_DE_LINHAS}&idtransportadora=${idtransportadora}&filter=${filter}` : `/veiculoslist/${id}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return { 
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    } }
};
export const VeiculosService = {
  getAll,
  create,
  getById,
  updateById,
  deleteById,
  getAllList,
};